import axios, { AxiosResponse } from 'axios'

import { LoginFormData } from '../../@paco/entities/@forms/LoginForm/LoginForm'
import { AccessToken } from '../../@paco/entities/AccessToken'

export const authenticateUserRequest = (credentials: LoginFormData): Promise<AxiosResponse<AccessToken>> => axios.post(`${process.env.REACT_APP_API_URL}/auth/token`, {
    username: credentials.username,
    password: credentials.password,
})

export const refreshAccessToken = (refreshToken: string) => axios.post(`${process.env.REACT_APP_API_URL}/auth/token/refresh`, {
    refresh_token: refreshToken,
})

export const forgotPasswordRequest = (email: string, userId: string) => {
    if (userId) {
        return axios.post(`${process.env.REACT_APP_API_URL}/users/${userId}/forgot-password`)
    }

    return axios.post(`${process.env.REACT_APP_API_URL}/auth/forgot-password/${email}`)
}

export const patchUserPassword = (userId: string, password: string, pincode: string) => {
    const body = {
        type: 'users',
        id: userId,
        attributes: {
            ...(password && { password }),
            ...(pincode && { pincode }),
        },
    }

    return axios.patch(
        `${process.env.REACT_APP_API_URL}/users/${userId}/`,
        { data: body },
    )
}
